var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownLogoDkbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 679,
    height: 400,
    viewBox: "0 0 679 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "CrownLogo--Gradient",
    clipPath: "url(#clip0_2_2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 679,
    height: 400,
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -103,
    y: -208,
    width: 867,
    height: 864
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "triangles"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left-triangle",
    d: "M162.333 119.91L457.174 328.969L220.03 330.2L162.333 119.91Z",
    stroke: "black",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-triangle",
    d: "M473.613 309.013L522.045 116.961L356.788 226.334L473.613 309.013Z",
    stroke: "black",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "top-triangle",
    d: "M264.693 162.452L337.197 53.5791L413.063 161.645L336.331 212.498L264.693 162.452Z",
    stroke: "black",
    strokeWidth: 10
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "gradient",
    width: 679,
    height: 400,
    fill: "url(#paint0_linear_2_2)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2",
    x1: 379.873,
    y1: 443.537,
    x2: 491.139,
    y2: -43.5101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583627,
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    className: "stop3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 679,
    height: 400,
    fill: "white"
  })), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            svg {\n\t            --base: #8E12C7;\n                --orange: #EA9863;\n\t            --highlight: #EA9863;\n                --raisin: #1D1E2C;\n            }\n\n            .stop1 {\n\t            stop-color: var(--base);\n                animation: iluminate 2s infinite alternate;\n            }\n\n            .stop2 {\n                --highlight: #8E12C7;\n\t            stop-color: var(--orange);\n                animation: iluminate 3s infinite alternate;\n            }\n\n            .stop3 {\n\t            stop-color: var(--orange);\n\t            stop-opacity: 0.41;\n            }\n\n            @keyframes iluminate {\n\n\t            to {\n\t\t            stop-color: var(--highlight);\n\t            }\n            }\n        "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownLogoDkbg);
export default __webpack_public_path__ + "static/media/CrownLogo--dkbg.74430b885224dd0c5d267a252337398c.svg";
export { ForwardRef as ReactComponent };